import { Box } from '@mui/material';

const BadgeWrapper = ({
  backgroundColor = 'transparent',
  children,
  onClick = () => {},
}) => {
  return (
    <Box
      position="relative"
      sx={{
        borderRadius: { xs: 1, lg: 2 },
        zIndex: 1,
        cursor: 'pointer',
        backgroundColor: backgroundColor,
      }}
      onClick={onClick}
    >
      {children}
    </Box>
  );
};

export default BadgeWrapper;
